export default __webpack_public_path__ + "static/media/bar-offers-1.f2c1d8b7.png";